<template>
  <div>
    <!-- Loading State -->
    <div v-if="isLoading" class="text-center py-5">
      <b-spinner variant="primary" label="Loading..." style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3 h5">Loading Expense information...</p>
    </div>

    <!-- Expense Content -->
    <b-card v-else>
      <!-- Header -->
      <div
        style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;"
      >
        <h4
          style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;"
        >
          Expense Information
        </h4>
      </div>

      <b-row>
        <!-- Title -->
        <b-col md="4" cols="12">
          <b-form-group label="Title:">
            <b-form-input v-model="expense.title" disabled />
          </b-form-group>
        </b-col>

        <!-- Expense Date -->
        <b-col md="4" cols="12">
          <b-form-group label="Expense Date:">
            <b-form-input v-model="expense.expense_date" disabled />
          </b-form-group>
        </b-col>

        <!-- Expense Type -->
        <b-col md="4" cols="12">
          <b-form-group label="Expense Type:">
            <b-form-input :value="expense.type?.name" disabled />
          </b-form-group>
        </b-col>

        <!-- Amount -->
        <b-col md="4" cols="12">
          <b-form-group label="Amount ($):">
            <b-form-input v-model="expense.amount" disabled />
          </b-form-group>
        </b-col>

        <!-- Document -->
        <b-col md="4" cols="12">
          <b-form-group label="Document:">
            <div style="margin-left: 3px; margin-bottom: 15px">
              <div v-if="expense.document">
                <!-- Image preview -->
                <div v-if="isImage(expense.document)">
                  <img
                    :src="fullUrl(expense.document)"
                    alt="Document"
                    width="100"
                    height="100"
                    style="cursor: pointer"
                    @click="openLightbox(fullUrl(expense.document))"
                  />
                </div>

                <!-- Other files -->
                <div v-else>
                  <i :class="fileIcon(expense.document)" style="margin-right: 5px"></i>
                  <b-button
                    @click="handleDocument(expense.document)"
                    variant="primary"
                    class="btn-sm"
                  >
                    Download Document
                  </b-button>
                </div>
              </div>
              <div v-else>
                <span>No document available</span>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <!-- Description -->
        <b-col md="12" cols="12">
          <b-form-group label="Description:">
            <b-form-textarea v-model="expense.description" rows="3" disabled />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- Lightbox -->
    <div v-if="lightboxVisible" class="lightbox" @click.self="closeLightbox">
      <div class="lightbox-content">
        <img :src="selectedImage" alt="Preview" class="lightbox-image" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";

export default {
  data() {
    return {
      expense: {},
      isLoading: true,
      lightboxVisible: false,
      selectedImage: null,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
  },
  created() {
    this.fetchExpense();
  },
  methods: {
    async fetchExpense() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          `expenses/${this.$route.params.id}`
        );
        this.expense = response.data.data;
      } catch (error) {
        console.error("Error fetching expense:", error);
      } finally {
        this.isLoading = false; // hide loader after API
      }
    },
    fullUrl(path) {
      return "https://wossdb.wossautoid.com/" + path;
    },
    openLightbox(imgPath) {
      this.selectedImage = imgPath;
      this.lightboxVisible = true;
    },
    closeLightbox() {
      this.lightboxVisible = false;
    },
    isImage(fileName) {
      return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
    },
    fileIcon(fileName) {
      if (/\.pdf$/i.test(fileName)) return "fas fa-file-pdf";
      if (/\.(csv|xls|xlsx)$/i.test(fileName)) return "fas fa-file-excel";
      if (/\.(doc|docx)$/i.test(fileName)) return "fas fa-file-word";
      return "fas fa-file-alt";
    },
    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", url.split("/").pop());
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleDocument(fileUrl) {
      const fullFilePath = this.fullUrl(fileUrl);
      if (this.isImage(fileUrl)) {
        this.openLightbox(fullFilePath);
      } else if (/\.pdf$/i.test(fileUrl)) {
        window.open(fullFilePath, "_blank");
      } else {
        this.downloadFile(fullFilePath);
      }
    },
  },
};
</script>

<style scoped>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.lightbox-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}
.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
}
</style>
